import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import UserGrid from './components/UserGrid';

function UserGridView(props) {
  const { loading } = props;
  const { t } = useTranslation();

  return (
    <AppNav flex notFullHeight loading={loading} page="support_users" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar title={t('userSettings.usersPageTitle')} />
        <UserGrid />
      </Box>
    </AppNav>
  );
}

export default UserGridView;
